import { useContext } from 'react'
import departments from '../../../../shared/common/values/departments'
import Department from './Department'
import { GameContext, SetUpdateContext } from '../../App'

export default function DepartmentList() {
	const gameState = useContext(GameContext)
	const update = useContext(SetUpdateContext)
	if (gameState === null) throw new Error('No gameState')
	const { purchases } = gameState

	const topIdPurchased = purchases.reduce(
		(topId, purchase) => Math.max(topId, purchase.id),
		0
	)
	return (
		<div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
			{departments.map((department, index) => {
				const purchased = purchases.some((purchase) => purchase.id === index)
				if (purchased || index < topIdPurchased + 3)
					return (
						<Department
							key={index}
							department={department}
							quantity={
								purchased
									? (purchases.find((purchase) => purchase.id === index)
											?.quantity ?? 0)
									: 0
							}
							allowSublime={department.sublime && !purchased}
							hideDetails={index > topIdPurchased}
							onClick={
								update !== null
									? () => {
											return update({
												id: crypto.randomUUID(),
												type: 'buy',
												data: {
													id: index,
													quantity: 1
												}
											})
										}
									: () => {
											throw new Error('No update')
										}
							}
						/>
					)
			})}
		</div>
	)
}
